import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CallToAction = () => {
  const actionItems = [
    {
      title: 'View My Projects',
      description: 'Explore my portfolio of full-stack applications and case studies',
      icon: 'FolderOpen',
      link: '/projects',
      variant: 'default',
      color: 'text-primary'
    },
    {
      title: 'Check My Experience',
      description: 'Detailed work history and professional achievements',
      icon: 'Briefcase',
      link: '/experience',
      variant: 'outline',
      color: 'text-success'
    },
    {
      title: 'Technical Skills',
      description: 'Comprehensive overview of my technical expertise',
      icon: 'Code',
      link: '/skills',
      variant: 'outline',
      color: 'text-accent'
    },
    {
      title: 'Get In Touch',
      description: 'Ready to discuss your next project or opportunity',
      icon: 'Mail',
      link: '/contact',
      variant: 'secondary',
      color: 'text-warning'
    }
  ];

  const quickStats = [
    {
      icon: 'Clock',
      value: '4.5+',
      label: 'Years Experience',
      color: 'text-primary'
    },
    {
      icon: 'CheckCircle',
      value: '30+',
      label: 'Projects Completed',
      color: 'text-success'
    },
    {
      icon: 'Users',
      value: '10+',
      label: 'Team Members Led',
      color: 'text-accent'
    },
    {
      icon: 'Award',
      value: '99%',
      label: 'Client Satisfaction',
      color: 'text-warning'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Main CTA Section */}
      <div className="bg-gradient-to-r from-primary/10 to-accent/10 rounded-lg p-8 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-3xl font-bold text-text-primary mb-4">
            Let's build something impactful together!
          </h2>
          <p className="text-text-secondary text-lg mb-6 leading-relaxed">
          I'm passionate about building scalable web apps, SaaS products, and WordPress solutions that drive business growth. Whether you need a Full-Stack MERN developer, a WordPress plugin expert, or a collaborative teammate - I'd love to connect and bring your ideas to life.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact">
              <Button variant="default" size="lg" className="w-full sm:w-auto">
                <Icon name="Mail" size={20} className="mr-2" />
                Hire Me as Your Technical Partner
              </Button>
            </Link>
            <Link to="/projects">
              <Button variant="outline" size="lg" className="w-full sm:w-auto border-2 border-slate-300 dark:border-input">
                <Icon name="Eye" size={20} className="mr-2" />
                View My Work
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="bg-surface rounded-lg p-6 shadow-md border border-border">
        <h3 className="text-xl font-bold text-text-primary text-center mb-6">
          Professional Highlights
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {quickStats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 mx-auto mb-3 bg-muted rounded-full flex items-center justify-center">
                <Icon name={stat.icon} size={24} className={stat.color} />
              </div>
              <div className="text-2xl font-bold text-text-primary mb-1">{stat.value}</div>
              <div className="text-sm text-text-secondary">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Actions */}
      <div className="bg-surface rounded-lg p-6 shadow-md border border-border">
        <h3 className="text-xl font-bold text-text-primary mb-6">Explore More</h3>
        <div className="grid md:grid-cols-2 gap-4">
          {actionItems.map((item, index) => (
            <Link key={index} to={item.link} className="block">
              <div className="p-4 bg-muted rounded-lg hover:shadow-md transition-all duration-200 hover:scale-105">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-background rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name={item.icon} size={20} className={item.color} />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-text-primary mb-1">{item.title}</h4>
                    <p className="text-text-secondary text-sm leading-relaxed">{item.description}</p>
                  </div>
                  <Icon name="ArrowRight" size={16} className="text-text-secondary mt-1" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Contact Information */}
      <div className="bg-surface rounded-lg p-6 shadow-md border border-border">
        <div className="text-center">
          <h3 className="text-xl font-bold text-text-primary mb-4">Let's Connect</h3>
          <p className="text-text-secondary mb-6">
            I'm always open to discussing new opportunities, interesting projects, 
            or just having a chat about technology and development.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <div className="flex items-center text-text-secondary">
              <Icon name="Mail" size={16} className="mr-2" />
              <span>contact.dishantpatel@gmail.com</span>
            </div>
            <div className="flex items-center text-text-secondary">
              <Icon name="Phone" size={16} className="mr-2" />
              <span>+91 814-147-5777</span>
            </div>
            <div className="flex items-center text-text-secondary">
              <Icon name="MapPin" size={16} className="mr-2" />
              <span>Surat, IN</span>
            </div>
          </div>
          
          <div className="flex justify-center space-x-4 mt-6">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => window.open('https://github.com/DishantMadariya', '_blank')}
              title="GitHub Profile"
            >
              <Icon name="Github" size={20} />
            </Button>
            {/* <Button
              variant="ghost"
              size="icon"
              onClick={() => window.open('https://linkedin.com/in/dishantmadariya', '_blank')}
              title="LinkedIn Profile"
            >
              <Icon name="Linkedin" size={20} />
            </Button> */}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => window.open('https://twitter.com/dishant_patel14', '_blank')}
              title="Twitter Profile"
            >
              <Icon name="Twitter" size={20} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;